import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { getMergedProductDescriptionByTabId, getUserPreferencesUnderlyingCodeType } from 'state/selectors';
import type { AppState } from 'state/state.model';
import {
  getBatchProductSubType,
  getBatchProductType,
  getFormIdsInBatchTab,
} from 'state/workspaces/batch/tabContent/tabContent.selectors';

import type { BatchFormGridOwnProps, BatchFormGridStateProps } from './BatchFormGrid.models';

export const mapStateToProps: MapStateToProps<BatchFormGridStateProps, BatchFormGridOwnProps, AppState> = (
  state,
  ownProps,
) => {
  const formIds = getFormIdsInBatchTab(state, ownProps.tabId);
  const productDescription = getMergedProductDescriptionByTabId(state, ownProps.tabId);
  const defaultUnderlyingCodeType = getUserPreferencesUnderlyingCodeType(state);
  return {
    formIds,
    productDescription,
    productSubtype: getBatchProductSubType(state, ownProps.tabId)!,
    productType: getBatchProductType(state, ownProps.tabId)!,
    defaultUnderlyingCodeType,
  };
};

export const connectedBatchFormGrid = connect<BatchFormGridStateProps, {}, BatchFormGridOwnProps, AppState>(
  mapStateToProps,
);
